import React from "react";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetActiveTempReport from "./hooks/useGetActiveTempReport";
import { CSVLink } from "react-csv";
import { UsersIcon } from "@heroicons/react/24/solid";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { employeeFromReports } from "../../Employees/Confie/atoms/atoms";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { EmployeeTabs } from "../../../EmployeeTab/EmployeeTab";
import DownloadButton from "../../../../components/DownloadButton";
import { accountAtom } from "../../../Login/atoms/AccountAtom";

interface IActiveTempReport {
  fullname: string;
  employmenttype: string;
  title: string;
  storeNumber: string;
  officeName: string;
  department: string;
  employeeTypeName: string;
  hiredate: string;
  terminationdate: string;
  rehireDate: string;
  reportsToFullname: string;
}
export const ActiveTempReport = () => {
  const { data: activeTempReport, isLoading: activeTempLoading } =
    useGetActiveTempReport();
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [, setShowFromReports] = useRecoilState(employeeFromReports);
  const user = useRecoilValue(accountAtom);

  //Date Format
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("/");
  }

  //For downloading table data
  const exportdata = activeTempReport
    ?.filter((x) =>
      user.isFranchise && user.isNonFranchise
        ? x.employeeTypeName !== ""
        : user.isFranchise
        ? x.employeeTypeName?.toLowerCase() === "franchise"
        : x.employeeTypeName?.toLowerCase() !== "franchise"
    )
    .map((emp: IActiveTempReport) => {
      return {
        "Full Name": emp.fullname,
        "Employment Type": emp.employmenttype,
        Title: emp.title,
        "Corporate Office #": emp.storeNumber,
        "Office Name": emp.officeName,
        Department: emp.department,
        "Employee Type": emp.employeeTypeName,
        "Hire Date": emp.hiredate ? formatDate(emp.hiredate) : "",
        "Termination Date": emp.terminationdate
          ? formatDate(emp.terminationdate)
          : "",
        "Rehire Date": emp.rehireDate,
        "Reports To": emp.reportsToFullname,
      };
    });
  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "ActiveTempReport_" + dateTimeToday + ".csv",
    data: exportdata ? exportdata : [],
  };
  const employeeColumns = [
    {
      title: "Full Name",
      field: "fullname",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/employeetab/employee";
              history.push({
                pathname: url,
                state: {
                  employeeNumber: rowData?.employeeid,
                  action: "EmployeeActiveTempReports",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...EmployeeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
              setShowFromReports(true);
            }}
          >
            <span className="text-quinary font-bold  underline text-sm ">
              {rowData.fullname}
            </span>
          </div>
        );
      },
    },
    { title: "Employment Type", field: "employmenttype" },
    { title: "Title", field: "title" },
    { title: "Corporate Office #", field: "storeNumber" },
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  officeCode: rowData?.officecode,
                  action: "ActiveTempReport",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...OfficeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },

    { title: "Department", field: "department" },
    { title: "Employee Type", field: "employeeTypeName" },
    {
      title: "Hire Date",
      field: "hiredate",
      render: (rowDetails) => {
        return (
          <div>
            <span className=" ">
              {rowDetails.hiredate ? formatDate(rowDetails.hiredate) : ""}
            </span>
          </div>
        );
      },
    },
    {
      title: "Termination Date",
      field: "terminationdate",
      render: (rowDetails) => {
        return (
          <div>
            <span className=" ">
              {rowDetails.terminationdate
                ? formatDate(rowDetails.terminationdate)
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      title: "Rehire Date",
      field: "rehireDate",
      render: (rowDetails) => {
        return (
          <div>
            <span className=" ">
              {rowDetails.rehireDate
                ? new Date(rowDetails.rehireDate)?.toLocaleDateString()
                : ""}
            </span>
          </div>
        );
      },
    },
    { title: "Reports To", field: "reportsToFullname" },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <UsersIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Employees & Offices
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                Active Temp Report
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {user.isFranchise && user.isNonFranchise
                  ? activeTempReport?.length
                  : activeTempReport?.filter(
                      (x) =>
                        x.employeenumber !== "" &&
                        (user.isFranchise
                          ? x.employeeTypeName?.toLowerCase() === "franchise"
                          : x.employeeTypeName?.toLowerCase() !== "franchise")
                    ).length}
              </span>
            </div>

            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => exportdata}
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={
              user.isFranchise && user.isNonFranchise
                ? activeTempReport
                : activeTempReport?.filter(
                    (x) =>
                      x.employeenumber !== "" &&
                      (user.isFranchise
                        ? x.employeeTypeName?.toLowerCase() === "franchise"
                        : x.employeeTypeName?.toLowerCase() !== "franchise")
                  )
            }
            isLoading={activeTempLoading}
            columns={employeeColumns}
            showTitle={false}
          />
        </div>
      </div>
    </div>
  );
};
